import React from "react";
import { useSiteContent } from "../context/ContentContext";
import { ButtonLink } from "../components/ButtonLink";
import {
  Breadcrumbs,
  Card,
  FeatureGrid,
  MembershipCard,
  PageHero,
  PolicyAlert,
  PriceList,
  SectionHeading,
  TextBlock,
} from "../components/RedlandComponents";
import { MembershipDocuments } from "../components/MembershipDocuments";

export default function Memberships() {
  const { memberships, contact } = useSiteContent();
  return (
    <>
      <Breadcrumbs current="Memberships" />
      <PageHero
        eyebrow="Join the RGCC Community"
        title={memberships.title}
        copy={memberships.intro[0]}
        image={memberships.heroImage}
        badge="Open to Public Play and Member Golf"
        tags={["Family", "Single", "Junior", "Social", "Winter"]}
        metaTitle="Member Highlights"
        metaItems={["10% restaurant discount", "Free range balls", "GHIN Handicap"]}
        actions={
          <>
            <ButtonLink href={contact.phoneHref}>Call 305-247-8503</ButtonLink>
            <ButtonLink href="#membership-documents" variant="secondary">
              Membership Documents
            </ButtonLink>
          </>
        }
      />

      <section className="section">
        <div className="container">
          <div className="narrow intro-copy">
            <TextBlock text={memberships.intro.slice(1).join("\n\n")} />
          </div>
          <SectionHeading title="Golf Membership Benefits" copy={memberships.annualPaymentNote} />
          <FeatureGrid items={memberships.benefits} />
        </div>
      </section>

      <section className="section section-cream">
        <div className="container">
          <SectionHeading title="Membership Pricing" />
          <div className="card-grid three">
            {memberships.pricing.map((membership) => (
              <MembershipCard key={membership.name} {...membership} />
            ))}
          </div>
        </div>
      </section>

      <section className="section">
        <div className="container card-grid two">
          <Card>
            <h2>Winter Golf Memberships</h2>
            <h3>Requirements</h3>
            <ul className="clean-list">
              {memberships.winter.requirements.map((item) => (
                <li key={item}>{item}</li>
              ))}
            </ul>
          </Card>
          <div className="stack">
            <PriceList title="Family Pricing" rows={memberships.winter.familyPricing} />
            <PolicyAlert title="Single Winter Membership" tone="green">
              {memberships.winter.singlePricing}
            </PolicyAlert>
          </div>
        </div>
      </section>

      <section className="section section-cream">
        <div className="container">
          <PolicyAlert title="Initiation Fee">{memberships.initiationFee}</PolicyAlert>
        </div>
      </section>

      <section className="section">
        <div className="container card-grid two">
          <Card>
            <h2>Social Membership Conditions</h2>
            <ul className="clean-list">
              {memberships.socialConditions.map((item) => (
                <li key={item}>{item}</li>
              ))}
            </ul>
          </Card>
          <Card>
            <h2>Important Membership Notes</h2>
            <ul className="clean-list">
              {memberships.importantNotes.map((item) => (
                <li key={item}>{item}</li>
              ))}
            </ul>
          </Card>
        </div>
      </section>

      <MembershipDocuments />

      <section className="section">
        <div className="container narrow center">
          <TextBlock text="Call 305-247-8503 to discuss membership." />
          <ButtonLink href={contact.phoneHref}>Call Membership</ButtonLink>
        </div>
      </section>
    </>
  );
}
